import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
    selector   : 'eguard-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls  : ['./confirm-dialog.component.scss']
})
export class EguardConfirmatialogComponent implements OnInit
{
    public confirmMessage: string;

    constructor(public dialogRef: MatDialogRef<EguardConfirmatialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any){
           
    }

    ngOnInit()
    {
        this.confirmMessage = this.data.confirmMessage;
    }

}



// WEBPACK FOOTER //
// ./src/app/core/components/confirm-dialog/confirm-dialog.component.ts